

import { Outlet, Route, Routes } from 'react-router-dom';

import Home from '@/pages/Home';
import { ContatoRoutes } from './Contato';
import { AcademicoRoutes } from './Academico';
import { PesquisaRoutes } from './Pesquisa';
import { FeagriRoutes } from './Feagri';
import { EstudeConoscoRoutes } from './EstudeConosco';


const ExtranetRoutes = () => {
    return (
        <Routes>

            <Route element={<Outlet />}>

                <Route index element={<Home />} />

                <Route path='/academico/*' element={<AcademicoRoutes />} />

                <Route path='/estude-conosco/*' element={<EstudeConoscoRoutes />} />

                <Route path='/feagri/*' element={<FeagriRoutes />} />

                <Route path='/contato/*' element={<ContatoRoutes />} />

                <Route path='/pesquisa/*' element={<PesquisaRoutes />} />
            
            </Route>

        </Routes>
    )
}

export { ExtranetRoutes };